import { render } from "./DailyRecords.vue?vue&type=template&id=f53316bc&scoped=true"
import script from "./DailyRecords.vue?vue&type=script&lang=js"
export * from "./DailyRecords.vue?vue&type=script&lang=js"

import "./DailyRecords.vue?vue&type=style&index=0&id=f53316bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53316bc"]])

export default __exports__